import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import PaymentMethodLearnMoreModal from './PaymentMethodLearnMoreModal';
export const usePaymentMethodLearnMoreModal = function usePaymentMethodLearnMoreModal() {
    let isDesktop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    const overlayContext = useOverlayContext();
    return ()=>{
        overlayContext.showModal({
            biName: 'payment_method_learn_more_modal',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(PaymentMethodLearnMoreModal, {
                    isDesktop: isDesktop,
                    dismissModal: dismissModal
                });
            },
            closeOnClickOutside: true,
            closeOnEscapeKey: true
        });
    };
};
